export const ValidationUtils = {
  methods: {
    validateDate (newDate, question) {
      const re = /^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/
      if (!re.test(newDate)) {
        this.errorDate = 'The Date Of Birth must be valid and in the format MM/dd/yyyy'
      } else if (this.isFutureDate(newDate)) {
        this.errorDate = 'The Date Of Birth should not be in the future'
      } else if (this.isOldDate(newDate)) {
        this.errorDate = 'Date Of Birth should not be more than 120 years in the past'
      } else {
        this.errorDate = ''
      }
    },
    validateDateService (newDate, question) {
      const re = /^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/
      if (!re.test(newDate)) {
        this.errorDate = 'The Date Of Service must be valid and in the format MM/dd/yyyy'
      } else if (this.isFutureDate(newDate)) {
        this.errorDate = 'The Date Of Service should not be in the future'
      } else {
        this.errorDate = ''
      }
    },
    validateQuestionDate (newDate, question) {
      if (newDate !== '') {
        const re = /^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/
        if (!re.test(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date must be valid and in the format MM/dd/yyyy')
        } else if (newDate.length === 10 && this.isFutureDate(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date should not be in the future')
        } else if (newDate.length === 10 && this.isCustomMonthsOlder(newDate, 2)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date cannot be older than 2 months')
        } else if (newDate.length === 10 && this.isOldDate(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date should not be more than 120 years in the past')
        } else {
          this.setQuestionInvalidStatus(newDate, question, 0, '')
        }
      } else {
        this.questionErrorDate[question.id] = false
        this.$set(this.questionErrorDate, question.id, false)
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (this.$store.state.questions[q].id === question.id) {
            this.$store.state.questions[q].answer = undefined
          }
        }
      }
    },
    setQuestionInvalidStatus (newDate, question, status, message) {
      message = message || ''
      if (question) {
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (this.$store.state.questions[q].id === question.id) {
            if (status === 1) {
              this.$store.state.questions[q].answer = ' '
              this.questionErrorDate[question.id] = message
              this.$set(this.questionErrorDate, question.id, message)
            } else {
              if (typeof this.$store.state.questions[q].answer_pretty !== 'undefined') {
                let dateParts = this.$store.state.questions[q].answer_pretty.split('/')
                this.$store.state.questions[q].answer = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
              }
              this.questionErrorDate[question.id] = false
              this.$set(this.questionErrorDate, question.id, false)
            }
          }
        }
      }
    },
    isFutureDate (verifiedDate) {
      const today = new Date().getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (today - date) < 0
    },
    isOldDate (verifiedDate) {
      const today = new Date().getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (today - date) > 3786831116964
    },
    isCustomMonthsOlder (verifiedDate, months) {
      let pastDate = new Date()
      pastDate.setMonth(pastDate.getMonth() - parseInt(months))
      pastDate = pastDate.getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (pastDate > date)
    },
    /**
     * Custom Questions Validation Rules
     * @param question
       */
    registrationQuestionsValidation (question) {
      let validQuestion = true
      if (this.apply_cdc_question_formatter) {
        validQuestion = this.showDateOfSymptomIfCDCIsYes(question)
      }
      return validQuestion
    },
    /**
     *
     * Show the: "If yes, then date of symptom onset" question if "Symptomatic as defined by CDC?" 's answer is Yes
     * @returns {boolean}
       */
    showDateOfSymptomIfCDCIsYes (question) {
      question = question || false
      if (question && typeof question.name !== 'undefined') {
        return (question.name.toLowerCase().indexOf(this.symptomatic_onset_question_name.toLowerCase()) === -1 || question.display === 1)
      }
      return true
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Validation.js